import ConfirmSignupFormCreationModal from './ConfirmSignupFormCreationModal';

export default ConfirmSignupFormCreationModal;
